<template>
  <div class="control-bar-lower">
    <div class="control-bar-lower-segment control-bar-lower-left-segment">
      <div id="chart-styles-dropdown-menu-container">
        <label :for="SELECT_CHART_STYLE_BUTTON" id="select-chart-style-button-label" class="sc3-form-label">CHARTSTYLES</label>
        <YourChartStylesDropdownMenu />
      </div>
      <button
        class="sc3-button sc3-button-green sc3-button-control-bar-lower-size"
        type="button"
        @click="launchSaveChartStyleModal()"
      >
        <i class="fas fa-fw fa-plus-circle" aria-hidden="true"></i>
        <span class="small-tablet-hidden">&nbsp;Save ChartStyle</span>
      </button>
      <button
        class="sc3-button sc3-button-transparent-and-dark-grey sc3-button-control-bar-lower-size"
        :class="{ 'sc3-button-active': savedChartsStore.recidOfDefaultChartStyle !== INVALID_CHART_STYLE_RECID && chartStore.recidOfChartStyleBeingViewedWithAllChangesSaved === savedChartsStore.recidOfDefaultChartStyle }"
        type="button"
        @click="[blurSetAsDefaultChartStyleButtonNode(), launchSetAsDefaultChartStyleModal()]"
        ref="setAsDefaultChartStyleButtonNode"
      >
        <i class="fas fa-fw fa-star" aria-hidden="true"></i>
        <span class="small-tablet-hidden">&nbsp;Set As Default</span>
      </button>
    </div>
    <div class="control-bar-lower-segment control-bar-lower-right-segment">
      <button
        type="button"
        title="Create Alert"
        class="sc3-button sc3-button-orange sc3-button-control-bar-lower-size"
        @click="launchCreatePriceAlertModal()"
        :disabled="isSymbolBeingViewedNotFound"
      ><i class="fas fa-fw fa-bell-plus"></i></button>
      <button
        type="button"
        title="Link To Chart"
        class="sc3-button sc3-button-grey sc3-button-control-bar-lower-size"
        @click="launchLinkToChartModal()"
      ><i class="far fa-fw fa-link"></i></button>
      <button
        type="button"
        title="Print Chart"
        class="sc3-button sc3-button-grey sc3-button-control-bar-lower-size"
        @click="printChart()"
      ><i class="far fa-fw fa-print"></i></button>
      <ShareDropdownMenu />
      <MoreDropdownMenu />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { ref } from 'vue';
  import { useChartStore } from '@/stores/chartStore';
  import { useSavedChartsStore } from '@/stores/savedChartsStore';
  import { useSymbolInformation } from '@/composables/useSymbolInformation';
  import { usePrintChart } from '@/composables/usePrintChart';
  import { useModals } from '@/composables/useModals';
  import { INVALID_CHART_STYLE_RECID } from '@/composables/isValidChartStyleRecid';
  import MoreDropdownMenu from '@/components/dropdowns/MoreDropdownMenu.vue';
  import ShareDropdownMenu from '@/components/dropdowns/ShareDropdownMenu.vue';
  import YourChartStylesDropdownMenu from '@/components/dropdowns/YourChartStylesDropdownMenu.vue';
  import { SELECT_CHART_STYLE_BUTTON } from '@/enums/html-ids';

  const chartStore = useChartStore();
  const savedChartsStore = useSavedChartsStore();
  const { isSymbolBeingViewedNotFound } = useSymbolInformation();
  const { printChart } = usePrintChart();
  const {
    launchCreatePriceAlertModal,
    launchSaveChartStyleModal,
    launchSetAsDefaultChartStyleModal,
    launchLinkToChartModal
  } = useModals();
  const setAsDefaultChartStyleButtonNode = ref<HTMLButtonElement>();

  function blurSetAsDefaultChartStyleButtonNode() {
    setAsDefaultChartStyleButtonNode.value?.blur();
  }
</script>

<style scoped>
  .control-bar-lower {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 4px;
    text-align: left;
    padding: 4px;
    background-color: white;
    border: 1px solid #c0ced8;
    border-left: none;
    border-right: none;
    justify-content: space-between;
  }

  .control-bar-lower-segment {
    display: inline-flex;
    align-items: end;
  }

  .control-bar-lower-left-segment {
    text-align: left;
    justify-content: start;
    display: grid;
    grid-template-columns: 1fr auto auto;
    gap: 4px;
    max-width: 620px;
    min-width: 0px;
  }

  .control-bar-lower-right-segment {
    text-align: right;
    font-size: 14px;
    justify-content: end;
    display: grid;
    grid-template-columns: auto auto auto auto auto;
    gap: 4px;
  }

  #chart-styles-dropdown-menu-container {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0px;
  }

  .screen-size-phone #chart-styles-dropdown-menu-container {
    flex-direction: column;
    align-items: start;
    gap: 0px;
  }

  #select-chart-style-button-label {
    margin: 0px 0px 0px 3px;
    font-size: 10px;
  }

  .screen-size-phone .control-bar-lower,
  .screen-size-small-tablet .control-bar-lower,
  .screen-size-tablet .control-bar-lower {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto;
  }

  .screen-size-phone .control-bar-lower-left-segment,
  .screen-size-small-tablet .control-bar-lower-left-segment,
  .screen-size-tablet .control-bar-lower-left-segment {
    grid-row: 2;
  }

  .screen-size-phone .control-bar-lower-right-segment,
  .screen-size-small-tablet .control-bar-lower-right-segment,
  .screen-size-tablet .control-bar-lower-right-segment {
    grid-row: 1;
  }
</style>
